import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import TransEn from "./i18n-trans-en";
import TransTh from "./i18n-trans-th";

const resources = {
  en: {
    translation: TransEn,
  },
  th: {
    translation: TransTh,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("language") || "th",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
